import { WindowTitle } from "@saleor/components/WindowTitle";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import BrandVerticalsComponent from "./views/BrandVerticalList";
const BrandVerticals: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <BrandVerticalsComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Brand Verticals",
          description: "brand verticals report section name"
        })}
      />

      <Routes>
        <Route path={""} element={<BrandVerticals />} />
      </Routes>
    </>
  );
};

export default Component;
